/**
 * Distribution REST API origin (no trailing slash).
 * Uses NODE_ENV: development → REACT_APP_DISTRIBUTION_API_URL_DEV, else → REACT_APP_DISTRIBUTION_API_URL_PROD.
 */
export function getBaseUrl() {
  const isDev = process.env.NODE_ENV === "development";
  const raw = isDev
    ? process.env.REACT_APP_DISTRIBUTION_API_URL_DEV
    : process.env.REACT_APP_DISTRIBUTION_API_URL_PROD;
  const url = raw != null ? String(raw).trim() : "";
  if (!url) {
    const key = isDev
      ? "REACT_APP_DISTRIBUTION_API_URL_DEV"
      : "REACT_APP_DISTRIBUTION_API_URL_PROD";
    console.warn(`${key} is not set; distribution API calls will be skipped.`);
    return null;
  }
  return url.replace(/\/$/, "");
}
